import { useGLTF } from '@react-three/drei'
import { useEffect } from 'react'

const LogoLeft = ({ model, logo, coords }) => {

  // console.log("left logo", logo)
  const url = model?.[logo]
  if (!url) return null // <-- prevent crash

  const { nodes, materials } = useGLTF(model[logo])

  useEffect(() => {
    if (!materials.SideWhite) return

    materials.SideWhite.roughness = 1
    materials.SideWhite.metalness = 0

    // BIG one
    materials.SideWhite.envMapIntensity = 0.5

    materials.SideWhite.needsUpdate = true
  }, [materials])


  return (
    <group dispose={null}>
      <group
        position={coords[logo].position}
        rotation={coords[logo].rotation}
        scale={coords[logo].scale}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh.geometry}
          material={materials.SideBlack}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_1.geometry}
          material={materials.SideWhite}
        />
      </group>
    </group>
  )
}

export default LogoLeft






